import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { selectHas3dObjects, selectHasLabels, selectHasRegions, selectLayerVisibility, selectMapConfig, selectMapName, selectMapSupportsLiveLocation, selectTitleName, toggleLayerVisibility } from '@repo/store/maps/slices/mapData';
export const useLayerControl = () => {
  const $ = _c(16);
  const dispatch = useAppDispatch();
  const layerVisibility = useAppSelector(selectLayerVisibility);
  const hasLabels = useAppSelector(selectHasLabels);
  const hasRegions = useAppSelector(selectHasRegions);
  const has3dObjects = useAppSelector(selectHas3dObjects);
  const supportsLiveLocation = useAppSelector(selectMapSupportsLiveLocation);
  const mapConfig = useAppSelector(selectMapConfig);
  const mapName = useAppSelector(selectMapName);
  const titleName = useAppSelector(selectTitleName);
  const analytics = useAnalytics();
  const hostType = useHostType();
  let t0;
  if ($[0] !== analytics || $[1] !== dispatch || $[2] !== hostType || $[3] !== layerVisibility || $[4] !== mapConfig || $[5] !== mapName || $[6] !== titleName) {
    t0 = layer => {
      const enabled = !layerVisibility[layer];
      dispatch(toggleLayerVisibility(layer));
      if (analytics && mapConfig?.externalId && titleName && hostType) {
        analytics.event("game_map_layer_toggle", {
          mapId: mapConfig.externalId,
          mapName: mapName ?? undefined,
          titleId: mapConfig.titleId,
          titleName,
          layer,
          enabled,
          platform: hostType
        });
      }
    };
    $[0] = analytics;
    $[1] = dispatch;
    $[2] = hostType;
    $[3] = layerVisibility;
    $[4] = mapConfig;
    $[5] = mapName;
    $[6] = titleName;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const handleToggleLayer = t0;
  const hasAnyLayerOption = hasLabels || hasRegions || has3dObjects || supportsLiveLocation;
  let t1;
  if ($[8] !== handleToggleLayer || $[9] !== has3dObjects || $[10] !== hasAnyLayerOption || $[11] !== hasLabels || $[12] !== hasRegions || $[13] !== layerVisibility || $[14] !== supportsLiveLocation) {
    t1 = {
      layerVisibility,
      hasLabels,
      hasRegions,
      has3dObjects,
      supportsLiveLocation,
      hasAnyLayerOption,
      handleToggleLayer
    };
    $[8] = handleToggleLayer;
    $[9] = has3dObjects;
    $[10] = hasAnyLayerOption;
    $[11] = hasLabels;
    $[12] = hasRegions;
    $[13] = layerVisibility;
    $[14] = supportsLiveLocation;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  return t1;
};